import {
  INBOX_ADD_TO_CASE_SUCCESS,
  INBOX_FETCH_CASES_REQUESTED,
  INBOX_FETCH_CASES_SUCCESS,
  INBOX_FETCH_CASES_FAILED,
  INBOX_CASES_RESET,
  INBOX_ADD_TO_CASE_FAILED,
  INBOX_ADD_TO_CASE_REQUESTED,
  INBOX_HANDLE_MARKED_LABELS_LIST,
  INBOX_RESET_MARKED_LABELS,
  INBOX_ADD_MARKED_LABELS_REQUESTED,
  INBOX_ADD_MARKED_LABELS_SUCCESS,
  INBOX_ADD_MARKED_LABELS_ERROR,
  INBOX_REMOVE_LABEL_REQUESTED,
  INBOX_REMOVE_LABEL_SUCCESS,
  INBOX_REMOVE_LABEL_ERROR,
  INBOX_SET_FOR_CASE_REQUESTED,
  INBOX_SET_FOR_CASE_SUCCESS,
  INBOX_SET_FOR_CASE_ERROR,
} from './actionTypes'
import { InboxActionTypes } from './types'
import produce from 'immer'
import {
  CasesQueryStatusEnum,
  CasesSortColumnEnum,
  IBoardCase,
  IBoardCaseFilter,
} from 'Modules/Boardwork/Meetings/shared/models/BoardCase'
import { ISortOrderEnum } from 'shared/models/List'
import { IEmailModel } from 'Modules/Communication/Email/shared/models/Email'
import { ISmsModel } from 'Modules/Communication/Sms/shared/models/Sms'

const initialState = {
  cases: {
    data: [] as IBoardCase[],
    loading: false,
    error: null as string | null,
    processing: false,
    processingError: null as string | null,
    success: false,
    filters: {
      queryStatus: CasesQueryStatusEnum.ActiveCases,
      sortOrder: ISortOrderEnum.desc,
      searchText: '',
      sortColumn: CasesSortColumnEnum.Created,
      take: -1, // Otherwise it defaults to 10 results.
    } as IBoardCaseFilter,
  },
  markedLabels: {
    data: [] as string[],
    loading: false,
    error: null as boolean | null,
  },
  removeLabelsQueue: [] as string[],
  messageForCase: {
    data: null as IEmailModel | ISmsModel | null,
    loading: false,
    error: false,
  },
}

const reducer = (state = initialState, action: InboxActionTypes) => {
  switch (action.type) {
    case INBOX_ADD_TO_CASE_REQUESTED: {
      return produce(state, (draft) => {
        draft.cases.processing = true
        draft.cases.processingError = null
        draft.cases.error = null
      })
    }

    case INBOX_ADD_TO_CASE_SUCCESS: {
      return produce(state, (draft) => {
        draft.cases.success = true
        draft.cases.processing = false
      })
    }
    case INBOX_ADD_TO_CASE_FAILED: {
      return produce(state, (draft) => {
        draft.cases.processing = false
        draft.cases.processingError = action.payload
        draft.cases.error = null
      })
    }

    case INBOX_FETCH_CASES_REQUESTED: {
      return produce(state, (draft) => {
        draft.cases.loading = true
        draft.cases.error = null
      })
    }
    case INBOX_FETCH_CASES_SUCCESS: {
      return produce(state, (draft) => {
        draft.cases.loading = false
        draft.cases.data = action.payload
      })
    }
    case INBOX_FETCH_CASES_FAILED: {
      return produce(state, (draft) => {
        draft.cases.loading = false
        draft.cases.error = action.payload
      })
    }
    case INBOX_CASES_RESET: {
      return produce(state, (draft) => {
        draft.cases.data = []
        draft.cases.loading = false
        draft.cases.processing = false
        draft.cases.success = false
        draft.cases.error = null
        draft.cases.processingError = null
      })
    }

    case INBOX_HANDLE_MARKED_LABELS_LIST: {
      return produce(state, (draft) => {
        draft.markedLabels.data = action.payload
      })
    }

    case INBOX_RESET_MARKED_LABELS: {
      return produce(state, (draft) => {
        draft.markedLabels.data = []
        draft.markedLabels.error = null
        draft.markedLabels.loading = false
      })
    }

    case INBOX_ADD_MARKED_LABELS_REQUESTED: {
      return produce(state, (draft) => {
        draft.markedLabels.loading = true
        draft.markedLabels.error = null
      })
    }
    case INBOX_ADD_MARKED_LABELS_SUCCESS: {
      return produce(state, (draft) => {
        draft.markedLabels.data = []
        draft.markedLabels.loading = false
        draft.markedLabels.error = null
      })
    }
    case INBOX_ADD_MARKED_LABELS_ERROR: {
      return produce(state, (draft) => {
        draft.markedLabels.loading = false
        draft.markedLabels.error = true
      })
    }

    case INBOX_REMOVE_LABEL_REQUESTED: {
      return produce(state, (draft) => {
        draft.removeLabelsQueue.push(action.payload.id)
      })
    }

    case INBOX_REMOVE_LABEL_SUCCESS: {
      return produce(state, (draft) => {
        draft.removeLabelsQueue = draft.removeLabelsQueue.filter(
          (item) => item !== action.payload
        )
      })
    }

    case INBOX_REMOVE_LABEL_ERROR: {
      return produce(state, (draft) => {
        draft.removeLabelsQueue = draft.removeLabelsQueue.filter(
          (item) => item !== action.payload
        )
      })
    }

    case INBOX_SET_FOR_CASE_REQUESTED: {
      return produce(state, (draft) => {
        draft.messageForCase.loading = true
        draft.messageForCase.data = null
        draft.messageForCase.error = false
      })
    }

    case INBOX_SET_FOR_CASE_SUCCESS: {
      return produce(state, (draft) => {
        draft.messageForCase.loading = false
        draft.messageForCase.data = action.payload
      })
    }

    case INBOX_SET_FOR_CASE_ERROR: {
      return produce(state, (draft) => {
        draft.messageForCase.loading = false
        draft.messageForCase.error = true
      })
    }

    default:
      return state
  }
}

export default reducer
